import React, { useState, useMemo } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _ from 'lodash';
import { Input, Tooltip } from 'antd';
import { TableStore } from 'stores/abstract';
import { CarStore } from 'stores';
import { SearchOutlined } from '@ant-design/icons';

const FilterSection = styled.div`
  display: flex;
  max-width: 900px;
  margin-bottom: 12px;
  && > div {
    flex: 1;
    display: inline-flex;
    align-items: center;
    margin-right: 20px;
  }
  && > div p {
    width: 80px;
    margin-bottom: 0;
  }
  && > div input {
    flex: 1;
  }
`;

const CarListFilter = ({ tableStore = {}, setFilter }) => {
  const [filter, setFilterState] = useState(
    tableStore ? { ...tableStore.filter } : {}
  );

  const filterValue = async (key, value) => {
    const newFilter = { ...filter };

    if (_.isEmpty(value)) {
      delete newFilter[key];
    } else {
      newFilter[key] = value;
    }

    setFilterState(newFilter);
    setFilter(key, value);
  };

  const filterValueFetch = async (key, value) => {
    let updatedFilter = { ...tableStore.filter, [key]: value };
    const limit = tableStore.limit;
    const sort = tableStore.sort;

    if (!value || value.length === 0) {
      delete updatedFilter[key];
    }

    await CarStore.getShopCarsForTable(
      {
        offset: 0,
        filter: updatedFilter,
        limit,
        sort,
      },
      tableStore
    );
  };

  const filterFields = useMemo(
    () => [
      {
        section: 1,
        fields: [
          { key: 'make', placeholder: 'Make' },
          { key: 'model', placeholder: 'Model' },
          { key: 'year', placeholder: 'Year' },
        ],
      },
      {
        section: 2,
        fields: [
          { key: 'vin', placeholder: 'Vin' },
          { key: 'carName', placeholder: 'Unit ID' },
          { key: 'scanner', placeholder: 'Device' },
          { key: 'name', placeholder: 'Driver' },
        ],
      },
    ],
    []
  );

  const renderFilterField = ({ key, placeholder }) => (
    <div key={key}>
      <Tooltip trigger={['focus']} title={placeholder} placement="topLeft">
        <Input
          placeholder={placeholder}
          value={tableStore.loaded ? tableStore.filter?.[key] : filter?.[key]}
          prefix={<SearchOutlined />}
          onChange={(e) => filterValue(key, e.target.value)}
        />
      </Tooltip>
    </div>
  );

  return (
    <>
      {filterFields.map((section, index) => (
        <FilterSection key={`section-${index}`}>
          {section.fields.map(renderFilterField)}
          {section.section === 1 && <div />}
        </FilterSection>
      ))}
    </>
  );
};

CarListFilter.propTypes = {
  tableStore: PropTypes.instanceOf(TableStore),
  userId: PropTypes.number,
  setFilter: PropTypes.func,
};

export default observer(CarListFilter);
